// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import {
  createValidator,
  getBinding,
} from "#stdnum-runtime";

const nhs: CountryValidator<"GB"> = createValidator(
  "gb.nhs",
  79,
);

export default nhs;
export const compact = nhs.compact;
export const format = nhs.format;
export const validate = nhs.validate;
export const calcCheckDigit = (
  value: string,
): number | null => getBinding().gbNhsCalcCheckDigit(value);
